import { Pipe, PipeTransform } from '@angular/core';
import { TransformObjectService } from './transform-object.service';

@Pipe({ name: 'transformObjects' })
export class TransformObjectsPipe<T> implements PipeTransform
{
  constructor(private transformObjectService: TransformObjectService) {}

  transform(objects: any[], objectKey: any, objDefaultValue?: Object): Array<T | any> {
    return objects && this.transformObjectService.transformObject<T | any>(objects, objectKey, objDefaultValue) as Array<T | any> || null;
  }

}
